import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Formik} from 'formik';
import {useTabStyles} from './utils';
import Loader from '../../../components/Loader/Loader';
import {
    callSettingsValidationSchema,
    ExtensionCallSettingsFormType,
} from '../../../components/Forms/Extensions/CallSettings/CallSettingsForm.utils';
import CallSettingsForm from '../../../components/Forms/Extensions/CallSettings/CallSettingsForm';
import {useEditExtensionCallSettingsFormData} from '../../../hooks/useEditExtensionCallSettingsFormData';
import {TabInterface} from '../../../components/Tabs/Tabs.utils';
import RestrictedMessageProvider, {ProviderTabName} from "../../AutoAttendants/Details/RestrictedMessageProvider";
import {ReduxState} from '../../../store/types';

const CallSettingsTab: React.VFC<TabInterface> = (
    {
        handleSubmitForm,
        handleInitDataChange,
        handleDirtyChange,
        handleSetSubmitFunc,
        handleSetIsValidFunc,
    }) => {
    // Styles
    const classes = useTabStyles();

    // Data hooks
    const {initFormData, data} = useEditExtensionCallSettingsFormData();

    // Redux selectors
    const isDataLoading = useSelector(
        (state: ReduxState) =>
            state.extensions.extensionDetailsTabs?.callSettingsTab?.isLoading ||
            false,
    );

    // Effects
    useEffect(() => {
        if (!isDataLoading && initFormData) {
            handleInitDataChange?.(initFormData);
            handleSubmitForm?.(initFormData);
        }
    }, [isDataLoading, initFormData]);

    // Render
    return isDataLoading ? (
        <div className={classes.loader}>
            <Loader dataQa="incoming-list-loader"/>
        </div>
    ) : (
        <RestrictedMessageProvider tabName={ProviderTabName.CallSettings}>
            <Formik<ExtensionCallSettingsFormType>
                initialValues={initFormData}
                validationSchema={callSettingsValidationSchema}
                onSubmit={handleSubmitForm!}
                enableReinitialize
                validateOnChange={false}
            >
                {() => (
                    <CallSettingsForm
                        handleDirtyChange={handleDirtyChange}
                        handleSetSubmitFunc={handleSetSubmitFunc}
                        handleSetIsValidFunc={handleSetIsValidFunc}
                        accountId={data?.extension?.account_id}
                        mohItems={data.mohItems}
                        i_account={data?.extension?.i_account}
                        callRecordingEmail={data?.email}
                    />
                )}
            </Formik>
        </RestrictedMessageProvider>
    );
};

export default CallSettingsTab;
